import * as React from 'react';
import {useState, useMemo, useRef} from 'react';
import Typography from '@mui/material/Typography';
import {AppCTX} from '../data/AppContext';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import PinDropIcon from '@mui/icons-material/PinDrop';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import CallIcon from '@mui/icons-material/Call';
import AddProspect from './AddProspect';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ClientDetails from './ClientDetails';
import HomeInsights from './HomeInsights';
import SetAppointment from './SetAppointment';
import Slide from '@mui/material/Slide';


export default function ProspectsList() {
  const {map, newProspect, setStatus, prospects, setNewProspect, deleteProspect} = React.useContext(AppCTX);
  const [openAddProspect, setOpenAddProspect] = React.useState(false);
  const [showDetails, setShowDetails] = useState(false)
  const [updateProspect, setUpdateProspect] = useState(null)
  const [newAppointment, setNewAppointment] = useState(null)
  const containerRef = useRef(null)

  React.useEffect(() => {
    console.log('add prospect state', openAddProspect)
  },[openAddProspect])

  // React.useEffect(() => {
  //   if(map && newProspect.coords) {
  //     const addProspectBtn = document.createElement("button");
  //     addProspectBtn.addEventListener("click",()=>{
  //       setOpenAddProspect(!openAddProspect);
  //       addAddress()
  //     })
  //     addProspectBtn.textContent = "Add Prospect";
  //     addProspectBtn.classList.add("addprospect-map-control-button");
  //     map.controls[9].push(addProspectBtn);

  //     return () => {map.controls[9].pop()};
  //   }
  // },[map, newProspect])


  const handleCreateAppointment = (prospect) => {
    setNewAppointment(prospect)
  }

  const handleClickOpen = (prospect) => {
    setUpdateProspect(prospect)
    map.panTo(prospect.coords)
    map.setZoom(20)
    setShowDetails(true);
  };

  const panToLocation = (prospect) => {
    console.log(prospect.coords)
    navigator.clipboard.writeText(prospect.address)
    map.panTo(prospect.coords)
    setStatus({notificationType:'success', message: 'address copied to clipboard'})
  }

  const renderProspectList = useMemo(()=>{
    const prospectsList =  prospects.map((prospect) => {
      const primaryContact = prospect.owners[0]
      let secondaryContact = false
      if(prospect.owners.length>1) {
        secondaryContact = prospect.owners[1]
      }
      return (
        <Stack id={`${primaryContact.name}-${primaryContact.number}`} key={`${primaryContact.name}-${primaryContact.number}`} direction="row" spacing={2}>
          <ListItem
            alignItems="flex-start"
          >
            <ListItemButton sx={{width:'80%'}} onClick={()=>handleClickOpen(prospect)}>
              <ListItemText
                primary={secondaryContact?`${primaryContact.name} & ${secondaryContact.name}`:`${primaryContact.name}`}
                secondary={
                  <>
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'block' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {`${prospect.notes[prospect.notes.length-1]}`}
                      </Typography>
                    </React.Fragment>
                  </>
                }
            />
            </ListItemButton>
            <ButtonGroup orientation="vertical" size="large" aria-label="large button group">
              <IconButton onClick={()=>panToLocation(prospect)} aria-label="delete">
                <PinDropIcon/>
              </IconButton>
              <IconButton href={`tel:${primaryContact.number}`} aria-label="delete">
                <CallIcon/>
              </IconButton>
            </ButtonGroup>
            <ButtonGroup orientation="vertical" size="large" aria-label="large button group">
              <IconButton onClick={()=>handleCreateAppointment(prospect)} aria-label="delete">
                <AddBoxIcon/>
              </IconButton>
              <IconButton onClick={()=>deleteProspect(prospect.address)} aria-label="delete">
                <DeleteIcon/>
              </IconButton>
            </ButtonGroup>
          </ListItem>
        </Stack>
      )
    })
    return(prospectsList)
  },[prospects])

  return (
    <>
      <Slide in container={containerRef.current}>
        <List sx={{ width: '90%', marginRight:'10px', marginLeft:'10px' }}>
          {prospects.length===0?
            <Typography variant="subtitle1" gutterBottom>
              To add a prospect pick a house by tapping on the map. A button with the text "Add prospect" will appear on the right side of the map. Tap this button to start entering prospect details and add them to your list.
            </Typography>
            :renderProspectList
          }
        </List>
      </Slide>
      <ClientDetails
        selectedProspect={updateProspect}
        open={showDetails}
        setShowDetails={setShowDetails}
        setSelectedProspect={setUpdateProspect}
      />
      <HomeInsights />
      <SetAppointment
        setNewAppointment={setNewAppointment}
        prospect={newAppointment}
      />
      <AddProspect/>
    </>
  );
}
